<template>
  <div class="timeline">
    <div class="player">
      <a v-if="interval === null" @click.prevent="start" v-html="svg.start" data-ga-click-event="ツールパス再生ボタン"></a>
      <a v-else @click.prevent="stop" v-html="svg.stop"></a>
      <input v-model="t" type="range" min="0.0" max="1.0" step="0.00001" @input="onChange" />
      <input class="speed" v-model="speed" type="number" min="0.1" max="5.0" step="0.1" />
    </div>
    <div class="toggle">
      <span>CNC</span>
      <div class="item">
        <input id="cnc" type="checkbox" :checked="cnc" @change="($e) => { $emit('cncvisible', !this.cnc); }" />
        <label for="cnc"></label>
      </div>
    </div>
    <div class="toggle">
      <span>Sheet</span>
      <div class="item">
        <input id="bin" type="checkbox" v-model="bin" @change="onBinVisible" />
        <label for="bin"></label>
      </div>
    </div>
    <div class="toggle">
      <span>Toolpath</span>
      <div class="item">
        <input id="toolpath" type="checkbox" v-model="toolpath" @change="onToolpathVisible" />
        <label for="toolpath"></label>
      </div>
    </div>
    <div class="toggle">
      <span>Tabs</span>
      <div class="item">
        <input id="tab" type="checkbox" v-model="tab" @change="onTabVisible" />
        <label for="tab"></label>
      </div>
    </div>
        <div class="toggle">
      <span>Screws</span>
      <div class="item">
        <input id="bisu" type="checkbox" v-model="bisu" @change="onBisuVisible" />
        <label for="bisu"></label>
      </div>
    </div>
    <div class="toggle">
      <span>Labels</span>
      <div class="item">
        <input id="labelinfo" type="checkbox" v-model="labelinfo" @change="onLabelinfoVisible" />
        <label for="labelinfo"></label>
      </div>
    </div>
  </div>
</template>

<script>

import svgTimelineStart from '../assets/images/ui/timeline-start.svg';
import svgTimelineStop from '../assets/images/ui/timeline-stop.svg';

export default {
  name: 'Timeline',
  components: {
  },
  props: {
    cnc: { type: Boolean, required: true }
  },
  data () {
    return {
      current: 0,
      frame: 60,
      speed: 1.0,
      length: 300,
      interval: null,
      svg: {
        start: svgTimelineStart,
        stop: svgTimelineStop
      },
      bin: false,
      toolpath: true,
      tab: false,
      bisu: false,
      labelinfo: false
    };
  },
  mounted () {
    this.current = Number(0);
  },
  computed: {
    t: {
      get () {
        return this.current;
      },
      set (v) {
        this.current = Number(v);
      }
    }
  },
  methods: {
    start () {
      if (this.current >= 1.0) {
        this.current = 0.0;
      }
      this.interval = setInterval(
        () => {
          this.step();
        },
        1000 / this.frame
      );
    },
    stop () {
      if (this.interval !== null) {
        clearInterval(this.interval);
      }
      this.interval = null;
    },
    step () {
      let dt = (this.frame / 1000) / this.length * this.speed;
      this.current = Number(this.current) + Number(dt);
      if (this.current >= 1.0) {
        this.current = 1.0;
        this.stop();
      }

      this.onChange();
    },
    onChange () {
      this.$emit('change', this.current);
    },
    onBinVisible () {
      this.$emit('binvisible', this.bin);
    },
    onToolpathVisible () {
      this.$emit('toolpathvisible', this.toolpath);
    },
    onTabVisible () {
      this.$emit('tabvisible', this.tab);
    },
    onBisuVisible () {
      this.$emit('bisuvisible', this.bisu);
    },
    onLabelinfoVisible () {
      this.$emit('labelinfovisible', this.labelinfo);
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/Timeline.vue